// uuid.js

let uuid = 0;
export default () => ++uuid;
